import type { ThemeDefinition } from "./types";
import { hexToSrgb, hexToLinear } from "./palette";

export const cobalt: ThemeDefinition = {
  label: "Cobalt",
  className: "theme-cobalt",
  bg: "#0e1830",
  text: "#90a8d0",
  textMuted: "rgba(144,168,208,0.55)",
  accent: "#d07050",
  glassRgb: "14,24,48",
  border: "rgba(255,255,255,0.08)",
  borderHighlight: "rgba(255,255,255,0.18)",
  separator: "rgba(144,168,208,0.18)",
  selection: "#d07050",
  selectionText: "#0e1830",
  gridColor: "#90a8d0",
  noiseOpacity: "0.05",
  gridOpacity: "0.7",
  textShadow: "0 -1px 0px rgba(255,255,255,0.1), 0 10px 0px rgba(0,0,0,0.55)",
  gpuClear: hexToSrgb("#0e1830"),
  gpuGridLine: hexToLinear("#90a8d0"),
  gpuGridAlpha: 0.7,
  gpuAxisX: hexToLinear("#d07050"),
  gpuAxisZ: hexToLinear("#90a8d0"),
  axisXColor: "#d07050",
  axisZColor: "#90a8d0",
  font: '"JetBrains Mono", monospace',
  fontImport: 'https://fonts.googleapis.com/css2?family=JetBrains+Mono:wght@300;400;500;600;700&display=swap',
};
